
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
//Charts
import ChartPie from 'Modules/dashboard/views/.components/chart/.components/pie'
import ChartBar from 'Modules/dashboard/views/.components/chart/.components/bar'
import ChartLine from 'Modules/dashboard/views/.components/chart/.components/line'

import { useSelector, useDispatch } from 'react-redux';
import { Loading } from '@gpstrackit/react-controls';

//Helpers
import { processGadgetData, parseNumberAndUnit } from 'Core/data/Helpers';

//Actions
import {
    chartDashboardPanel,
    vidfleetClipRequestDetailsOpenModal,
    firmwareRequestDetailsOpenModal,
    lastReadingRequestDetailsOpenModal,
} from 'Redux/actions';

//Styles
import './index.scss'

const backgroundColor = [
    '#66BB6A',
    '#03A9F4',
    '#1D2734',
    '#018F82',
    '#13B2A3',
    '#37AFCC',
    '#00C6FC',
    '#00ACFB',
    '#008CDD',
    '#0059A0',
    '#2F4F6C',
    '#6685A7',
    '#825C8D',
    '#812F6F',
    '#006014',
    '#007F25',
    '#40BE60',
    '#69C97D',
    '#A9EAB3',
    '#ECB651',
    '#EA6947',
    '#D13C3C',
    '#AC2A47',
    '#C23E68',
    '#E97694',
]

const Chart = ({ item, update }) => {

    const dispatch = useDispatch();
    const { locale, messages } = useIntl();
    const [typeChart, setTypeChart] = useState('');
    const [data, setData] = useState({});
    const [itemsChartData, setItemsChartData] = useState(null);
    const [count, setCount] = useState(0)
    const [flag, setFlag] = useState(0)

    const {
        charts_data,
    } = useSelector(state => state.gadgetChartRedux);

    const {
        updateResponse
    } = useSelector((state) => state.dashboardPanelMainRedux);

    useEffect(() => {
        if (updateResponse) {
            if (updateResponse.id == item.id) {
                dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
                setData({});
            }
        }
    }, [updateResponse])


    useEffect(() => {
        dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
        setData({});
    }, [update]);

    useEffect(() => {
        if (+charts_data?.id === +item.id) {
            setItemsChartData(charts_data.data[0]);
            if (charts_data?.error && flag === 2) {
                dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
                setFlag(flag + 1)
            }
            if (charts_data.data.length === 0) {
                const data = {
                    labels: [],
                    datasets: [{
                        label: 'Total',
                        data: [0],
                        backgroundColor: backgroundColor,
                        hoverOffset: 4
                    }],
                    type: 'ClipRequestByStatus',
                    subTitle: messages['vidfleetClips_no_data_to_display'],
                    unit: "Total"
                };
                setData(data)
            }
        }
    }, [charts_data]);

    const getLabels = (time) => {
        let labels = []
        let start = null
        let end = null
        switch (time) {
            case 'quarter':
                start = moment().startOf('quarter').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [];
                labels = [`${moment(start).format("MMM")}`];
                break;
            case 'today':
                start = moment().startOf('day').toDate()
                labels = [`${moment(start).format("yyyy/MM/DD")}`];
                break;
            case 'yesterday':
                start = moment().subtract(1, 'days').startOf('day').toDate()
                labels = [`${moment(start).format("yyyy/MM/DD")}`];
                break;
            case 'thisweek':
                start = moment().startOf('week').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'lastweek':
                start = moment().startOf('week').subtract(1, 'weeks').toDate()
                end = moment(start).add(1, 'week').endOf('day').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'thismonth':
                start = moment().startOf('month').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'lastmonth':
                start = moment(moment()).subtract(1, 'months').startOf('month').toDate()
                end = moment(moment()).subtract(1, 'months').endOf('month').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'thisquarter':
                start = moment().startOf('quarter').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).add(5, 'hours').format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).add(5, 'hours').format('yyyy/MM/DD')}`];
                break;
            case 'lastquarter':
                start = moment().quarter(moment().quarter() - 1).startOf('quarter').toDate()
                end = moment().quarter(moment().quarter() - 1).endOf('quarter').toDate()
                labels = [`${moment(start).add(5, 'hours').format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).add(5, 'hours').format('yyyy/MM/DD')}`];
                break;
            case 'thisyear':
                start = moment().startOf('year').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).add(5, 'hours').format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'lastyear':
                start = moment().subtract(1, 'years').startOf('year').toDate()
                end = moment().subtract(1, 'years').endOf('year').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'last7days':
                start = moment().subtract(7, 'days').startOf('day').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'last15days':
                start = moment().subtract(15, 'days').startOf('day').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
            case 'last30days':
                start = moment().subtract(30, 'days').startOf('day').toDate()
                end = moment.max(moment()).endOf('day').toDate()
                labels = [`${moment(start).format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(end).format('yyyy/MM/DD')}`];
                break;
        }
        return labels
    }

    const dataProcess = (settings, data) => {
        if (data?.developers.length) {
            let year = ['year', 'lastyear']
            if (year.includes(settings.timeMetric?.id)) {
                let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                let developers = data?.developers?.map((developer) => {
                    let information = []
                    developer?.labels?.map((item, key) => information.push({ month: item, value: developer?.values[key] }))
                    let values = months.map((month) => {
                        const monthData = information.find((d) => d?.month === month);
                        return (monthData ? monthData?.value : 0)
                    });
                    return { ...developer, values }
                })
                return developers
            } else {
                return data.developers
            }
        } else {
            if (settings.entities.length) {
                let developers = settings.entities?.map((developer) => {
                    return { label: developer.name, values: data.data }
                })
                return developers
            }
        }
    }

    useEffect(() => {
        if (itemsChartData) {
            let settings = JSON.parse(item.settings);
            if (settings && (charts_data?.data?.length > 0) && settings?.reportType?.id === "DeveloperMetrics") {
                settings?.chartType?.id && setTypeChart(settings.chartType.id);
                const dateStart = itemsChartData?.start;
                const dateEnd = itemsChartData?.end;
                let label = ''
                let deviceDataSet = []
                let developers = dataProcess(settings, itemsChartData)
                if (data)
                    if (developers) {
                        developers.map((item, index) => {
                            let values = item?.values
                            deviceDataSet.push({
                                stack: index + 1,
                                label: item?.label,
                                data: values,
                                backgroundColor: backgroundColor[index],
                                tension: 0.4
                            })
                        })
                    }
                let year = ['lastyear', 'year']
                let labels = year.includes(settings?.timeMetric?.id) ? itemsChartData?.label : settings?.timeMetric?.id === "quarter" ? getLabels("quarter") : itemsChartData?.label?.map((item) => moment(item).add(5, 'hours').format('MMM'))
                setCount(0);
                setFlag(0);
                setData({
                    labels: labels,
                    title: `${label}`,
                    subTitle: `${moment(dateStart).add(5, 'hours').format('yyyy/MM/DD')} ${messages['dashboardPanel_to']} ${moment(dateEnd).add(5, 'hours').format('yyyy/MM/DD')}`,
                    unit: 'Total',
                    legend: true,
                    data: itemsChartData?.data,
                    backgrounds: backgroundColor,
                    datasets: deviceDataSet
                });
            }
            if (settings?.dateTimeRange && charts_data && charts_data?.data && charts_data?.data?.length) {
                let labels = charts_data?.data ? charts_data?.data?.map((item) => item.status) : []
                let subTitle = getLabels(settings?.dateTimeRange)
                const data = {
                    labels,
                    datasets: [{
                        data: charts_data?.data.map((item) => item.qtty),
                        backgroundColor: backgroundColor,
                        hoverOffset: 4
                    }],
                    type: 'ClipRequestByStatus',
                    unit: 'Total',
                    subTitle: subTitle?.length ? subTitle[0] : ''
                };
                setData(data)
            }
            let types = ['VidFleetFirmware', 'UnitsThatStoppedReporting']
            if (types.includes(item.type) && charts_data?.data?.length) {
                setTypeChart(settings?.chartType)
                let data = processGadgetData(item.type, charts_data.data, itemsChartData, messages, settings)
                setData(data)
            }
        }

        if (charts_data?.error && charts_data?.id == item.id) {
            dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
        }

    }, [itemsChartData, locale]);

    const validateData = () => {
        if (!itemsChartData && count === 0) {
            dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
            setCount(1)
        }
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            validateData()
        }, 3000);
        return () => clearTimeout(timeoutId);
    }, [itemsChartData])

    const handleVidfleetStatuses = (status) => {
        dispatch(vidfleetClipRequestDetailsOpenModal(true, {
            gadgetId: item?.id,
            status: status
        }))
    }

    const handleFirmwares = (firmwareId) => {
        if (firmwareId !== "NA") {
            dispatch(firmwareRequestDetailsOpenModal(true, {
                gadgetId: item?.id,
                firmwareId: firmwareId
            }))
        }
    }

    const lastReading = (dataLine, total) => {
        let range = parseNumberAndUnit(dataLine)
        dispatch(lastReadingRequestDetailsOpenModal(true, {
            gadgetId: item?.id,
            start: range?.startNumber,
            end: range?.endNumber || data?.requestLimit
        }, total))
    }

    return (
        <div className="chart-main-container">
            {!data.hasOwnProperty('labels') &&
                <Loading overlay show />
            }
            {
                typeChart === 'pie' || data?.type === 'ClipRequestByStatus' &&
                <ChartPie data={data} onClick={handleVidfleetStatuses} />
            }
            {
                typeChart === 'column' &&
                <ChartBar data={data} onClick={data?.type == 'VidFleetFirmware' ? handleFirmwares : lastReading} />
            }
            {
                typeChart === 'line' &&
                <ChartLine data={data} />
            }
        </div>
    );
}

export default Chart;
